/**
 * Roles allowed to create and edit products.
 * Used by both API (authorization via @HasRole decorator) and frontend (UI gating).
 */
export const PRODUCT_EDIT_ROLES = ["Admin", "Broker"] as const;
export type ProductEditRole = (typeof PRODUCT_EDIT_ROLES)[number];

/**
 * Internal roles that have full access to the platform.
 * Used by both API and frontend for authorization checks.
 */
export const INTERNAL_ROLES = ["Admin", "ARM", "Binding", "Broker", "DJ", "UnderwritingAssistant"] as const;
export type InternalRole = (typeof INTERNAL_ROLES)[number];
